var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpopPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 46,
    viewBox: "0 0 438 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pin",
    fill: "white",
    stroke: "#ffc005",
    strokeWidth: 20,
    d: "M 201.54,6.60       C 173.07,10.72 153.17,15.69 127.98,30.65       55.22,73.87 27.55,159.80 51.20,239.05       67.41,293.35 107.42,335.17 141.53,378.88       167.46,412.11 183.92,437.69 197.29,477.75       201.01,488.90 204.60,507.02 219.93,505.68       233.32,504.51 236.68,486.89 240.20,476.34       252.26,440.22 265.71,419.32 288.04,388.77       333.08,327.13 386.11,282.09 392.62,200.92       392.62,200.92 393.91,185.38 393.91,185.38       394.07,151.43 386.74,120.13 369.23,90.75       335.61,34.32 267.48,-1.42 201.54,6.60 Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "triangle",
    points: "217,20 86,274 354,274",
    fill: "#ffc005"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpopPin);
export default __webpack_public_path__ + "static/media/spop_pin.bbd789b96a7fc3f42440a055f98cb420.svg";
export { ForwardRef as ReactComponent };